import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { FooterSection, LeadingTitle, LinkDocument, Pagination } from "@components";
import { Docs, Download } from "@icons";
import "./Prospectus.scss";
import { ReportAPINew, ShortDescriptionAPI } from "@api";
import moment from "moment";
import { useTranslation } from "react-i18next";
import queryString from "query-string";
import { useLocation } from "react-router-dom";

const CorporateContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Prospectus = function () {
  const query = useQuery();
  const {t} = useTranslation();
  const [shortDesc, setShortDesc] = useState(null);
  const [prospectusReport, setProspectusReport] = useState({});
  const page = query.get("page") || 1;

  useEffect(() => {
    const loadData = async function () {
      const filter = {
        cat: "Prospektus",
        orderBy: "desc",
        page: page,
      };
      const reportData = await ReportAPINew(queryString.stringify(filter));  
      setProspectusReport(reportData.data.data);
    };

    const loadShortDescData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: "prospektus" });
      setShortDesc(data.data);
    };

    if (!shortDesc) {
      loadShortDescData();
    }

    if (page) {
      loadData();
    }
  }, [shortDesc, page]);

  const createPagination = () => {
    const { total, per_page } = prospectusReport;
    return {
      totalItems: total,
      currentPage: +page,
      limit: per_page,
    }
  }

  return (
    <CorporateContainer>
      <LeadingTitle
        title={t("prospektus")}
        subtitle={shortDesc !== null ? shortDesc[0].description : ""}
      />

      <div className="prospektus-content">
        <div className="card-box">
          {prospectusReport != null
            ? prospectusReport.result?.map((data, i) => {
                return (
                  <LinkDocument
                    label={moment(
                      data.created_date,
                      "DD-MM-YYYY hh:mm:ss"
                    ).format("DD MMMM YYYY")}
                    labelIcon={Docs}
                    title={data.title}
                    linkLabel="Download"
                    linkIcon={Download}
                    linkRedirect={data.file}
                    key={i}
                  />
                );
              })
            : ""}
        </div>
        <nav className="pagination-box" aria-label="Public Expose Pagination">
          <ul className="pagination">
            <Pagination {...createPagination()} />
          </ul>
        </nav>
      </div>

      <FooterSection currentPage={t("prospektus")}/>
    </CorporateContainer>
  );
};

export default Prospectus;
